import React from "react";

import Zar8DashboardContent from "../../components/Zar8DashboardContent";
import Header from "../../layouts/Header";

export default function Zar8Track({
  basePath = "/zar8/track",
  routeFlowType = null,
}) {
  return (
    <div className="min-h-screen bg-[#F8F8F8]">
      <Header />
      <Zar8DashboardContent basePath={basePath} routeFlowType={routeFlowType} />
    </div>
  );
}
